import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DeclineCategoryRow } from '../interfaces/decline-reason-mapping.interface';
import { DeclineMappingGridContext, DeclineMappingGridHostApi } from '../interfaces/decline-mapping-grid-host.interface';

@Component({
  selector: 'decline-mapping-category-cell',
  templateUrl: './decline-mapping-category-cell.component.html',
  styleUrls: ['./decline-mapping-cell-renderers.styles.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeclineMappingCategoryCellComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>;

  @ViewChild('nameInput') set nameInputRef(ref: ElementRef<HTMLInputElement> | undefined) {
    if (ref) setTimeout(() => ref.nativeElement.focus());
  }

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<DeclineCategoryRow, unknown, DeclineMappingGridContext>): boolean {
    this.params = params;
    this.cdr.markForCheck();
    return true;
  }

  get host(): DeclineMappingGridHostApi | undefined {
    return this.params?.context?.host;
  }

  get row(): DeclineCategoryRow | undefined {
    return this.params?.data;
  }

  get editing(): boolean {
    return !!(this.row && this.host?.editingRowId === this.row.id);
  }

  get mappedCount(): number {
    return this.row && this.host ? this.host.rowMappedCount(this.row) : 0;
  }

  onNameClick(): void {
    if (!this.row || !this.host) return;
    this.host.startEdit(this.row);
  }

  onDraftChange(newName: string): void {
    this.host?.setEditDraft(newName);
  }

  onInputBlur(): void {
    if (this.editing) {
      this.host?.commitEdit(false);
    }
  }

  onInputKeydown(event: KeyboardEvent): void {
    this.host?.onEditKeydown(event);
  }
}
